import './src/styles/global.css'

export function onServiceWorkerUpdateReady() { window.location.reload(true) };